/** @file Runtime invariant check that narrows the condition for TypeScript. */
export function invariant(cond: unknown, msg: string): asserts cond {
  if (!cond) throw new Error(`Invariant violated: ${msg}`);
}
